<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">
        {{#if isEdit}}
        {{TR "Messwert bearbeiten"}}
        {{else}}
        {{TR "Messwert hinzufügen"}}
        {{/if}}
    </h4>
</div>

<div class="modal-body">
    <div class="form-group">
        {{#SELECT inputData.value}}
        <select class="selectpicker" data-style="btn-white" data-live-search="true" id="valuespecs-sel">
        {{#each values}}
            <option value="{{id}}">{{name}}</option>
        {{/each}}
        </select>
        {{/SELECT}}
    </div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button class="btn btn-primary" id="js-btn-add">
        {{#if isEdit}}
        {{TR "Speichern"}}
        {{else}}
        {{TR "Hinzufügen"}}
        {{/if}}
    </button>
</div>
